export function querystringify(queryObj: { [key: string]: unknown }): string {
  const safeQueryObj = new URLSearchParams();
  Object.keys(queryObj).forEach((key) => {
    if (queryObj[key] !== undefined && queryObj[key] !== null) {
      switch (typeof queryObj[key]) {
        case "number":
        case "boolean":
          safeQueryObj.append(key, encodeURIComponent(queryObj[key] as number | boolean));
          break;
        case "object":
          const keys = Object.keys(queryObj[key]);
          keys.forEach((childKey) => {
            safeQueryObj.append(key, encodeURIComponent((queryObj[key] as { [key: string]: unknown })[childKey] as string | number | boolean));
          })
          break;
        case "string":
        default:
          safeQueryObj.append(key, queryObj[key] as string);
          break;
      }
    }
  });

  return safeQueryObj.toString();
}
